module.exports = __webpack_public_path__ + "static/media/street-lamp.15f06720.png";